export function parseSearchTerms(search) {
  if (!search?.trim()) {
    return [];
  }

  return search
    .split(/[\n\r,;\t]+/)
    .map((term) => term.trim())
    .filter(Boolean);
}

function valueMatchesTerm(value, term) {
  return String(value).toLowerCase().includes(term.toLowerCase());
}

function matchValuesByTerms(allValues, terms) {
  if (!terms.length) {
    return allValues;
  }

  return allValues.filter((value) =>
    terms.some((term) => valueMatchesTerm(value, term))
  );
}

export function filterValuesBySearchTerms(allValues = [], search) {
  if (!search?.trim()) {
    return allValues;
  }

  const terms = parseSearchTerms(search);
  let filteredValues = matchValuesByTerms(allValues, terms);

  // Single-line inputs convert pasted newlines to spaces; split on whitespace as fallback.
  if (!filteredValues.length && terms.length === 1 && /\s/.test(terms[0])) {
    const spaceSeparatedTerms = terms[0]
      .split(/\s+/)
      .map((term) => term.trim())
      .filter(Boolean);

    if (spaceSeparatedTerms.length > 1) {
      filteredValues = matchValuesByTerms(allValues, spaceSeparatedTerms);
    }
  }

  return filteredValues;
}

export function sortValuesAlphabetically(values = []) {
  return [...values].sort((a, b) =>
    String(a).localeCompare(String(b), undefined, { sensitivity: "base" })
  );
}
